import React, { createContext, useCallback, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';

export const UserInfoContext = createContext({ currentUser: {}, currentHostUser: {}, verifyUserNip: () => {} });

function UserInfoProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [currentUser, setCurrentUser] = useState({});
  const [currentHostUser, setCurrentHostUser] = useState({});
  // console.log('usuario', currentUser);

  const getUserUtility = (utilityObj) => {
    const defaultObj = {
      ENVIO: { valueUser: 70, valUserOperator: 0.7, valueDag: 30, valDagOperator: 0.3 },
      RECARGA: { valueUser: 70, valUserOperator: 0.7, valueDag: 30, valDagOperator: 0.3 },
      SERVICIO: { valueUser: 70, valUserOperator: 0.7, valueDag: 30, valDagOperator: 0.3 },
      EMPAQUE: { valueUser: 70, valUserOperator: 0.7, valueDag: 30, valDagOperator: 0.3 },
      REP_MULTIMARCA: { valueUser: 70, valUserOperator: 0.7, valueDag: 30, valDagOperator: 0.3 }
    };

    if (utilityObj) {
      Object.entries(utilityObj).forEach(([key, value]) => {
        // console.log(key, value);
        defaultObj[key] = {
          valueUser: value,
          valUserOperator: value / 100,
          valueDag: 100 - value,
          valDagOperator: (100 - value) / 100
        };
      });
    }

    return defaultObj;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const assignedRoles = ['cajero', 'cliente-corporativo'];

  const getUserData = useCallback(async () => {
    await firestore
      .collection('users')
      .doc(user.id)
      .onSnapshot((snapshot) => {
        if (snapshot.exists) {
          const obj = {
            id: user.id,
            ...snapshot.data(),
            formatUserUtility: getUserUtility(snapshot?.data()?.userUtility || null)
          };
          setCurrentUser(obj);
        }
      });
  }, [user.id]);

  useEffect(() => {
    // console.log('se renderiza');
    // async function getUserInfo() {
    //   await firestore
    //     .collection('users')
    //     .doc(user.id)
    //     .onSnapshot((snapshot) => {
    //       if (snapshot.exists) {
    //         const obj = {
    //           id: user.id,
    //           ...snapshot.data()
    //         };
    //         setCurrentUser(obj);
    //       }
    //     });
    // }
    if (isAuthenticated) {
      // getUserInfo();
      getUserData();
    }
  }, [getUserData, isAuthenticated, user]);

  useEffect(() => {
    async function getHostUserInfo() {
      await firestore
        .collection('users')
        .doc(currentUser.hostUser)
        .onSnapshot((snapshot) => {
          if (snapshot.exists) {
            const obj = {
              id: currentUser.hostUser,
              ...snapshot.data(),
              formatUserUtility: getUserUtility(snapshot?.data()?.userUtility || null)
            };
            setCurrentHostUser(obj);
          }
        });
    }

    if ((currentUser?.role === 'cajero' || currentUser?.role === 'cliente-corporativo') && currentUser?.hostUser) {
      getHostUserInfo();
    }
  }, [currentUser]);

  useEffect(() => {
    if (!assignedRoles.includes(currentUser?.role)) {
      // console.log('no es cajero ni cliente corporativo');
      if (currentUser?.hostUser !== currentUser.id) {
        firestore.collection('users').doc(currentUser.id).update({ hostUser: currentUser.id });
      }
    }
  }, [assignedRoles, currentUser?.hostUser, currentUser.id, currentUser?.role]);

  const verifyUserNip = useCallback(
    (userNip) => {
      if (currentUser?.nip === userNip) {
        return true;
      }
      return false;
    },
    [currentUser]
  );

  return (
    <UserInfoContext.Provider value={{ currentUser, currentHostUser, verifyUserNip }}>
      {children}
    </UserInfoContext.Provider>
  );
}

export default UserInfoProvider;
